import { render, staticRenderFns } from "./VsTable.vue?vue&type=template&id=34b6477a&lang=pug&"
import script from "./VsTable.vue?vue&type=script&lang=js&"
export * from "./VsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b6477a')) {
      api.createRecord('34b6477a', component.options)
    } else {
      api.reload('34b6477a', component.options)
    }
    module.hot.accept("./VsTable.vue?vue&type=template&id=34b6477a&lang=pug&", function () {
      api.rerender('34b6477a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsTable.vue"
export default component.exports